import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, change} from 'redux-form';
import {Button, Form, Loader, Modal} from 'semantic-ui-react';
import {required} from '../../../../common/components/form/common/fieldValidations';
import {DropdownField, TextAreaField} from '../../../../common/components/form';
import {SCANNING_WAREHOUSE_DENIED_FORM} from '../../../../common/forms';
import {Actions} from '../../../../common/actions';
import './warehouseDenialCause.scss';

class WarehouseDenialCauseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {'open': false};
    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onOpenModal() {
    const {agency, replacementPart} = this.props;
    this.props.fetchReplacementPartOrderRequestsInfo(
      replacementPart.partCode,
      agency.code,
      agency.dealerIdentification
    );
    this.props.dispatch(
      change(
        SCANNING_WAREHOUSE_DENIED_FORM.name,
        'orderSequence',
        replacementPart.orderSequence
      )
    );
    this.props.fetchWarehouseDenialCausesList();
    this.setState({'open': true});
  }

  onCloseModal() {
    this.setState({'open': false});
  }

  getWarehouseDenialCauseOptions() {
    const {warehouseDenialCauses} = this.props;

    return warehouseDenialCauses.map((item) => ({
      'value': item.code,
      'text': item.name,
    }));
  }

  getQuantityOptions(maxValue) {
    return [...Array(maxValue).keys()].map((item) => ({
      'value': item + 1,
      'text': item + 1,
    }));
  }

  renderPartOrders(agencies) {
    if (agencies.length > 0) {
      const orders = agencies.map(
        (item) =>
          `${item.dealerName} - ${item.agencyName} (${item.orderQuantity})`
      );
      return (
        <div>
          {'Este item también a sido solicitado en: '}
          <span>{orders.join(', ')}</span>
        </div>
      );
    }

    return null;
  }

  renderInfoMessage() {
    const {
      loadingReplacementPartOrderRequestsInfo,
      replacementPartOrderRequestsInfo,
    } = this.props;

    if (loadingReplacementPartOrderRequestsInfo) {
      return <Loader active inline='centered' />;
    }

    if (!replacementPartOrderRequestsInfo) {
      return null;
    }

    return (
      <div className='info-message'>
        {this.renderPartOrders(replacementPartOrderRequestsInfo.agencies)}
        <div>
          <strong>Ubicación: </strong>
          {replacementPartOrderRequestsInfo.location}
        </div>
        <div>
          <strong>Stock: </strong>
          {replacementPartOrderRequestsInfo.stock}
        </div>
      </div>
    );
  }

  renderFormFields() {
    const {replacementPart, loadingWarehouseDenialCauses} = this.props;
    const pendingQuantity = replacementPart.pendingQuantity ?
      replacementPart.pendingQuantity :
      1;

    if (loadingWarehouseDenialCauses) {
      return <Loader active inline='centered' />;
    }

    return (
      <div className='modal-fields'>
        <div className='field-label'>
          <label>Cantidad*</label>
        </div>
        <div className='field-component'>
          <Field
            name='deniedQuantity'
            type='number'
            component={DropdownField}
            options={this.getQuantityOptions(pendingQuantity)}
            validate={required}
          />
        </div>
        <div className='field-label'>
          <label>Tipo de motivo*</label>
        </div>
        <div className='field-component'>
          <Field
            name='denialCauseCode'
            component={DropdownField}
            options={this.getWarehouseDenialCauseOptions()}
            validate={required}
          />
        </div>
        <div className='field-label'>
          <label>Descripción</label>
        </div>
        <div className='field-component'>
          <Field name='comments' component={TextAreaField} />
        </div>
      </div>
    );
  }

  render() {
    const {trigger, submitting, replacementPart, handleSubmit, submit} = this.props;

    return (
      <Modal
        size='tiny'
        className='warehouse-denial-cause'
        open={this.state.open}
        onOpen={this.onOpenModal}
        onClose={this.onCloseModal}
        trigger={trigger}
      >
        <Modal.Header>Agregar un motivo</Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <h4>{`(${replacementPart.partCode}) ${replacementPart.partName}`}</h4>
            <Form
              className='warehouse-denial-cause-form'
              loading={submitting}
              autoComplete='off'
            >
              {this.renderInfoMessage()}
              {this.renderFormFields()}
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            type='button'
            onClick={this.onCloseModal}
            disabled={submitting}
          >
            Cancelar
          </Button>
          <Button
            type='submit'
            primary
            onClick={
              handleSubmit(() => {
                this.onCloseModal();
                return submit();
              })
            }
            disabled={submitting}
          >
            Guardar
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export {WarehouseDenialCauseModal};

const form = reduxForm({
  'form': SCANNING_WAREHOUSE_DENIED_FORM.name,
})(WarehouseDenialCauseModal);

const mapStateToProps = (state, ownProps) => {
  return {
    'agency': ownProps.agency,
    'loadingReplacementPartOrderRequestsInfo':
      state.scanning.loadingReplacementPartOrderRequestsInfo,
    'replacementPartOrderRequestsInfo':
      state.scanning.replacementPartOrderRequestsInfo,
    'loadingWarehouseDenialCauses': state.warehouseDenialCauses.loading,
    'warehouseDenialCauses': state.warehouseDenialCauses.list,
  };
};

const {
  fetchReplacementPartOrderRequestsInfo,
  fetchWarehouseDenialCausesList,
} = Actions;

export default connect(mapStateToProps, {
  fetchReplacementPartOrderRequestsInfo,
  fetchWarehouseDenialCausesList,
})(form);
